/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import DnsIcon from "@mui/icons-material/Dns";
import BedIcon from "@mui/icons-material/Bed";
import LayersIcon from "@mui/icons-material/Layers";
import PlaceIcon from "@mui/icons-material/Place";
import OilBarrelIcon from "@mui/icons-material/OilBarrel";
import AirlinesIcon from "@mui/icons-material/Airlines";
import { SvgIconProps } from "@mui/material";
import { RosterIcon } from "RosterData";

const ICONS = {
  BED: BedIcon,
  BASE: DnsIcon,
  LAYER: LayersIcon,
  ONS: PlaceIcon,
  OFFS: OilBarrelIcon,
  HELI: AirlinesIcon,
};

interface DynamicIconProps extends SvgIconProps {
  iconName: RosterIcon;
}

const DynamicIcon = ({ iconName, ...props }: DynamicIconProps) => {
  const IconComponent = ICONS[iconName];
  return IconComponent ? (
    <IconComponent {...props} />
  ) : (
    <LayersIcon {...props} />
  );
};

export default DynamicIcon;
